<template>
  <div>
    <div
      v-if="!readonly"
      class="cfs-field d-flex flex-column"
      :class="{ 'static-bg': staticBg, 'warning-messages': warningMessages?.length }"
    >
      <p class="input-title px-1 pb-1" :class="{ disabled }">{{ label }}</p>
      <v-textarea
        dense
        outlined
        :messages="warningMessages"
        v-bind="{ ...$attrs, ...$props }"
        :placeholder="placeholder || label"
        :label="null"
        v-on="$listeners"
      ></v-textarea>
    </div>
    <CfsReadonlyField v-else v-bind="$props" />
  </div>
</template>

<script>
export default {
  components: {
    CfsReadonlyField: () => import('./special/CfsReadonlyFieldComponent.vue'),
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    warningMessages: {
      type: Array,
      default: null,
    },
    /**when set to false fills input with application background solid color instead of inherited one.
     * I.e. removes transparency from input*/
    staticBg: {
      type: Boolean,
      default: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss">
.warning-messages {
  .v-text-field {
    &__details {
      .v-messages {
        color: #e60909;
        font-weight: 600;
      }
    }
  }
}
</style>
